/**
 * GA4 (gtag) e Meta Pixel: solo in produzione.
 * In dev gli script su domini esterni possono generare "Script error." senza stack
 * (CORS / ad blocker / eccezioni nel tracker) e far scattare l’overlay runtime di CRA.
 */
const GA_MEASUREMENT_ID = 'G-FBQRXP420R';
const META_PIXEL_ID = '27394572846797583';

let marketingTagsBooted = false;

export function bootMarketingTags(): void {
  if (process.env.NODE_ENV !== 'production') return;
  if (marketingTagsBooted || typeof document === 'undefined') return;
  if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap')
    return;
  marketingTagsBooted = true;

  type MarketingWindow = Window & {
    dataLayer: unknown[];
    /* eslint-disable no-unused-vars -- parametri solo tipizzati */
    gtag: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
    /* eslint-enable no-unused-vars */
    _fbq?: unknown;
  };
  const w = window as unknown as MarketingWindow;

  w.dataLayer = w.dataLayer || [];
  function gtag() {
    w.dataLayer.push(arguments as unknown);
  }
  w.gtag = gtag as MarketingWindow['gtag'];

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(gtagScript);

  w.gtag('js', new Date());
  w.gtag('config', GA_MEASUREMENT_ID);

  // Snippet ufficiale Meta Pixel (stesso ordine/comportamento dell’HTML precedente).
  (function (
    f: any,
    b: Document,
    e: string,
    v: string,
    n?: any,
    t?: any,
    s?: any,
  ) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s?.parentNode?.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  );

  w.fbq?.('init', META_PIXEL_ID);
  w.fbq?.('track', 'PageView');
}
